import {Link, useLocation} from "react-router-dom";
import '../../scss/footer.scss';
import FooterWave from "../../svg/FooterWave";

function Footer({leftChildren, rightLinks, waveEnabled=true, backgroundColor}) {
	const location = useLocation();
	if (location.pathname.split('/')[1]==='admin') return(null);
	return(<>
		{waveEnabled&&<div className={'footerWave'}><FooterWave/></div>}
		<div className={'footerContainer'} style={backgroundColor?{backgroundColor:backgroundColor}:null}>
			<footer className={'footer'}>
				<div>
					{leftChildren}
				</div>
				<nav>
					{rightLinks&&rightLinks.map((link, i) => <Link key={i} to={link.l}>{link.t}</Link>)}
				</nav>
			</footer>
		</div>
	</>)
}

export default Footer;